module.exports = __webpack_public_path__ + "img/ic_photo.10451405.svg";